module.exports = __webpack_public_path__ + "public/images/main-after.5d2b54e080a8ec99dae45fae255c2c7e.svg";